export default "__VITE_ASSET__BzN095yh__"